export default __webpack_public_path__ + "static/media/banner3.f0aa1933.jpg";